// src/app/features/questionnaires/edit/TaxQuestionnaire/PersonalDetails/TheBasics/CovidRelief/attachments/uploadFields.ts
import { updateKeyInStore } from 'App';
import { CovidReliefStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof CovidReliefStateValues>[] = [
  {
    type: 'upload',
    name: 'firstGovStimulusCopy',
    label: 'Please Upload Notice 1444 (preferred)',
    subLabel: () => (
      <p>
        If you don't have this - it's ok. Please make sure to complete the
        amount below
      </p>
    ),
    tooltip: '',
    info: ['First government stimulus package'],
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.covid_relief.values.receivedCovidPaymentFirstOrSecond',

    predicate: (value) =>
      value === 'First stimulus check of $1200' ||
      value === 'I received both stimulus checks',
  },
  {
    type: 'upload',
    name: 'secondGovStimulusCopy',
    label: 'Please Upload Notice 1444 (preferred)',
    subLabel: () => (
      <p>
        If you don't have this - it's ok. Please make sure to complete the
        amount below
      </p>
    ),
    tooltip: '',
    info: ['Second government stimulus package'],
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.covid_relief.values.receivedCovidPaymentFirstOrSecond',
    predicate: (value) =>
      value === 'Second stimulus check of $600' ||
      value === 'I received both stimulus checks',
  },
];
